import React from 'react'
import '../../App.scss'
import './Home.scss'


import HeroSection from '../HeroSection'
import Technologies from '../Technologies'
import Services from '../Services'
import Footer from '../Footer'
import ContactUs from '../ContactUs'
import Subscribe from '../Subscribe'
import Wave from '../Wave'


function Home() {
    return (
        <>
            <div className="home-section">
                <HeroSection />
                <Services />
                <Wave color="#020617" backgroundColor="#ffffff" /> {/* Services(White) -> Tech(Dark #020617) */}
                <Technologies />
                <Wave color="#ffffff" backgroundColor="#020617" /> {/* Tech(Dark) -> Contact(White) */}
                <ContactUs />
                <Wave color="#020617" backgroundColor="#ffffff" /> {/* Contact(White) -> Subscribe(Dark #020617) */}
                <Subscribe />
                <Wave color="#ffffff" backgroundColor="#020617" /> {/* Subscribe(Dark) -> Footer(White) */}
                <Footer />
            </div>
        </>
    )
}

export default Home